var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import usePassPropsToChildren from '../../utils/hooks/usePassPropsToChildren';
import RadioGroupStyle from './RadioGroupStyle';
import RadioContext from './RadioContext';
const RadioGroup = (_a) => {
    var { disabled, error, name, horizontal, children: childrenProps } = _a, otherProps = __rest(_a, ["disabled", "error", "name", "horizontal", "children"]);
    const [checked, setChecked] = React.useState('');
    const { children } = usePassPropsToChildren(childrenProps, {
        disabled,
    });
    return (React.createElement(RadioContext.Provider, { value: {
            checked,
            setChecked,
            name,
            error,
        } },
        React.createElement(RadioGroupStyle, Object.assign({ horizontal: horizontal }, otherProps), disabled ? children : childrenProps)));
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map